export default {
    methods: {
        validatorForm(parent, prop = [], type) {
            let value = null;
            let key = type ? 'checkErrorValue' : 'checkValue';
            parent.$children.map((child) => {
                if (child.prop && child[key]) {
                    if (prop.length) {
                        if (prop.indexOf(child.prop) !== -1) {
                            if (value) {
                                child[key]();
                            } else {
                                value = child[key]();
                            }
                        }
                    } else {
                        if (value) {
                            child[key]();
                        } else {
                            value = child[key]();
                        }
                    }
                }
            });
            return value;
        },
        validatorError(parent) {
            return this.validatorForm(parent, [], true);
        },
        reset(parent) {
            parent.$children.map((child) => {

                if (child.reset && child.hasOwnProperty('cloneValue')) {
                    child.reset();
                }
                if (child._props.type === 'boxed') {
                    child.$children && child.$children.forEach(c => {
                        // console.log(c.$children)
                        c.$children && c.$children.forEach(c2 => {
                            // console.log(c2)
                            if (c2.hasOwnProperty('cloneValue')) {
                                c2.reset()
                            }
                        })
                    })
                }
            });
        },
        back() {
            this.$router.go(-1);
        }
    }
};
